import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UiSwitcherService {
  private _enabled = false;

  setEnabled(enabled: boolean): void {
    this._enabled = enabled;
  }

  get enabled(): boolean {
    return this._enabled;
  }
}